/** Auto-generated by scripts/sync-build-info.mjs — do not edit by hand. */
export const BUILD_META = {
  appVersion: '1.0.0',
  buildTag: 'cbe03a7b7eae080ab88520bbbfc750f19d4dd870',
} as const;
